import React from 'react';
import EditIcon from '@mui/icons-material/Edit';

import { notNullish } from '@paragon/utilities';

import { SelectedItemIdentifier } from '../../../../library/selection/types';
import { useAppMonitor } from '../../../../monitor';
import { handleStandardSceneItemsEditPropertiesAction } from '../../../../store/actions/sceneInteractionActions';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';

export function CeilingTrayMenu(props: { items: SelectedItemIdentifier[] }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const ceilingTrays = useAppSelector((state) =>
    props.items.map((item) => state.layout.ceilingTrays[item.guid]).filter(notNullish),
  );
  if (ceilingTrays.length < props.items.length) throw new Error('Unable to find ceiling tray with active menu.');

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Edit Properties"
        icon={<EditIcon />}
        onClick={async () => {
          await dispatch(handleStandardSceneItemsEditPropertiesAction('ceilingTray', ceilingTrays));
          monitor.recordInteraction('Ceiling Tray => Edit Properties menu item clicked');
        }}
      />

      <DeleteMenuItem
        type="ceilingTray"
        item={ceilingTrays}
        userVisibleTerm={ceilingTrays.length === 1 ? 'Ceiling Tray' : 'Ceiling Trays'}
      />
    </SceneMenuContent>
  );
}
